
    /**
     * @description
     *  Modelo para referencias personales. Actualmente parece no utilizarse
     *  en las bases de datos.
     *
     * @see gigot-backend/Models/Users/PersonalReference.cs
     */

export class PersonalReference {

    public address: string;
    public documentNumber: string;
    public firstName: string;
    public fullName: string;
    public homePhone: string;
    public id: number;
    public lastName: string;
    public mobilePhone: string;

    /**
     * @description
     *  Construye una referencia personal con una semántica vacía. Nótese que
     *  no es lo mismo que construir una referencia con valores por defecto.
     *  Las reglas generales de construcción son:
     *
     *      - Campos 'array' se definen como [].
     *      - Campos 'boolean' se definen como 'false'.
     *      - Campos 'Date' se definen como 'undefined'.
     *      - Campos 'enum' se definen como 'undefined'.
     *      - Campos 'number' se definen como 'undefined'.
     *      - Campos 'string' se definen como '' (cadena vacía).
     *      - Campos 'object' se definen llamando a su propio método #empty().
     *      - Campos de la superclase se definen al igual que campos 'object'.
     *      - Campos genéricos se definen como 'undefined'.
	 *		- Campos recursivos se definen como 'undefined'.
     *
     * @returns
     *	Una referencia personal vacía.
     */
    public static empty(): PersonalReference {
        const personalReference: PersonalReference = new PersonalReference();
        personalReference.address = "";
        personalReference.documentNumber = "";
        personalReference.firstName = "";
        personalReference.fullName = "";
        personalReference.homePhone = "";
        personalReference.id = undefined;
        personalReference.lastName = "";
        personalReference.mobilePhone = "";
        return personalReference;
    }

	/**
	 * @description
	 *  Método de reificación de un modelo compatible anémico. Esto permite
	 *  ejecutar lógica de negocios sobre el modelo generado, siendo que el
	 *  valor de sus propiedades se mantiene.
	 *
	 * @param anemicPersonalReference
	 *  El modelo anémico a reificar.
	 *
	 * @returns
	 *  Devuelve un modelo de esta clase, cuyas propiedades fueron copiadas en
	 *  profundidad desde el modelo anémico.
	 */
	public static from(anemicPersonalReference: PersonalReference): PersonalReference {
		if (!anemicPersonalReference) return undefined;
		const personalReference: PersonalReference = PersonalReference.empty();
		personalReference.address = anemicPersonalReference.address;
        personalReference.documentNumber = anemicPersonalReference.documentNumber;
        personalReference.firstName = anemicPersonalReference.firstName;
        personalReference.fullName = anemicPersonalReference.fullName;
        personalReference.homePhone = anemicPersonalReference.homePhone;
        personalReference.id = anemicPersonalReference.id;
        personalReference.lastName = anemicPersonalReference.lastName;
        personalReference.mobilePhone = anemicPersonalReference.mobilePhone;
        return personalReference;
	}
}
